import './index.css';
import * as React from 'react';
import { ScenceTabItemData } from '../component';

interface State {}

interface Props {
  scenceTabData: ScenceTabItemData;
  isSelected: boolean;
}

/**
 * 图文选择组件
 * @param apiData
 */
export default class ScenceTabItem extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  componentDidMount(): void {

  }

  componentWillUnmount(): void {

  }

  render() {
    const defaultImage = 'assets://placeholder/icon_placeholder_circle.png';
    const { text, pic } = this.props.scenceTabData || {};
    return (
      <view className="container">
        <view className="pic-container-wrapper">
          {this.props.isSelected && <image className="pic-container-selected" src="assets://scencetab/scence_item_selected.png" />}
          {/* 当选中但没兜底的情况下仅展示选中背景图 */}
          {(this.props.isSelected && !pic) ? null : <image className="pic-container-content" src={pic || defaultImage} placeholder={defaultImage} error={defaultImage} />}
        </view>
        <text className={this.props.isSelected ? 'text-selected' : 'text-normal'} content={text} />
      </view>
    );
  }
}
